import Icon from 'components/base/Icon';
import useTotalSummaryDiff from '../SyncGitTeamsForm/TotalSummary/useTotalSummaryDiff';
import { StyledWizardFooter } from '../SyncGitTeamsWizard.style';
import { StyledSummaryHeadcount, StyledSummaryWizard } from './Summary.style';
import characterConnectProjects from 'images/characters/character-connect-projects.svg';
import StatefulInfoBox from 'components/StatefulInfoBox';
import { boolPropsToClassNames } from 'common/utils/style.utils';
import { LineSkeleton } from 'components/base/Skeletons';
import get from 'lodash/get';
import { LBButton } from '@linearb/buzz';

const Loader = () => (
  <div className='summary-loader'>
    {[80, 60, 60, 60, 80].map(percent => (
      <div className='loader' key={percent}>
        <LineSkeleton size={percent} />
      </div>
    ))}
  </div>
);

const Summary = ({ onBack, onSave, sensorAuthId, orgName, selectedTeams }) => {
  const { summaryDiff, isLoading } = useTotalSummaryDiff({
    sensorAuthId,
    orgName,
    selectedTeams
  });
  const teamsToAdd = get(summaryDiff, 'teams_to_sync', []);
  const contributorsToAdd = [
    ...get(summaryDiff, 'contributors_to_add.existing_contributors_ids', []),
    ...get(summaryDiff, 'contributors_to_add.new_contributors_provider_ids', [])
  ];

  const teamsToRemove = get(summaryDiff, 'teams_to_delete', []);
  const contributorsToRemove = get(summaryDiff, 'contributors_to_remove', []);

  const totalTeamsExists = get(summaryDiff, 'total_teams_exist', 0);
  const totalContributorsExists = get(
    summaryDiff,
    'total_contributors_exist',
    0
  );

  const totalTeamsAfterChanges =
    Number(totalTeamsExists) +
    Number(teamsToAdd.length) -
    Number(teamsToRemove.length);
  const totalContributorsAfterChanges =
    Number(totalContributorsExists) +
    Number(contributorsToAdd.length) -
    Number(contributorsToRemove.length);

  return (
    <StyledSummaryWizard className={boolPropsToClassNames({ isLoading })}>
      <header>Changes summary:</header>
      {isLoading && <Loader />}
      {!isLoading && (
        <main>
          <div className='summary-columns'>
            <div className='col'>
              <header>
                <Icon name='EditUser' />
                <span className='title'>Adding</span>
              </header>
              <main className='summary-content'>
                <div className='row'>{teamsToAdd.length} Teams</div>
                <div className='row'>
                  {contributorsToAdd.length} Contributors
                </div>
              </main>
            </div>
            <div className='col'>
              <header>
                <Icon name='UserRemove' />
                <span className='title'>Removing (stopping GitHub sync)</span>
              </header>
              <main className='summary-content'>
                <div className='row'>{teamsToRemove.length} Teams</div>
                <div className='row'>
                  {contributorsToRemove.length} Contributors
                </div>
              </main>
            </div>
          </div>
          <StyledSummaryHeadcount>
            <div className='row'>
              Current count: {totalTeamsExists} teams and{' '}
              {totalContributorsExists} contributors
            </div>
            <div className='row'>
              New count: <b>{totalTeamsAfterChanges} teams</b> and{' '}
              <b>{totalContributorsAfterChanges} contributors</b>
            </div>
            <img
              src={characterConnectProjects}
              className='background-decorator'
            />
          </StyledSummaryHeadcount>

          <StatefulInfoBox>
            Teams and contributors removed from sync will no longer show in
            LinearB
          </StatefulInfoBox>
        </main>
      )}
      <StyledWizardFooter>
        <LBButton
          variant='outline'
          size='lg'
          onClick={onBack}
          data-cy='SyncGitTeamsForm-btn-back'
        >
          Back
        </LBButton>
        <LBButton
          size='lg'
          data-cy='SyncGitTeamsForm-btn-save'
          disabled={isLoading}
          onClick={onSave}
        >
          Approve and Save
        </LBButton>
      </StyledWizardFooter>
    </StyledSummaryWizard>
  );
};

export default Summary;
